function downloadVideo(url) { 
	var xhr = new XMLHttpRequest();
	xhr.open('GET', url, true);
	xhr.responseType = 'blob';
	xhr.onload = function () {
		var urlCreator = window.URL || window.webkitURL;
		var videoUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement('a');
        tag.href = videoUrl;
        tag.download = 'Augenmanufaktur';
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
	};
	xhr.onerror = err => {
		alert('Failed to download');
	};
	xhr.send();
}